<template>
  <v-container fluid class="currencyrate-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn @click="Refresh" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-refresh</v-icon>
                Refresh
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              v-model="item_seleted"
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="currencyrates-table"
              show-select
              single-select
              item-key="_id"
              sort-by="currencydate"
              sort-desc
              :footer-props="footer"
              :headers="header_items"
              :items="currencyrates"
              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="isDeleteRate"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this CurrencyRate?
                    </v-card-title>
                    <v-card-text>
                      {{ delete_rate.currencyname }}
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="isDeleteRate = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteCurrency(delete_rate)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.currencystatus="{ item }">
                <v-chip
                  :color="!item.currencystatus ? 'primaryConst white--text' : 'secondaryConst white--text'"
                  small>
                  {{ item.currencystatus }}
                </v-chip>
              </template>
              <template v-slot:item.currencybase="{ item }">
                <p class="two-line">{{ item.currencybase }} - {{ item.currencycross }}</p>
              </template>
              <template v-slot:item.currencydate="{ item }">
                {{ new Date(item.currencydate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.currencyrate="{ item }">
                <p class="two-line">{{ item.currencyrate.toFixed(2).toLocaleString('en-SG') }}</p>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="updateRateDialog(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <!-- <v-btn icon color="primary" @click="deteleRateDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn> -->
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <div>
      <v-dialog
        v-model="isEditRate"
        persistent
        width="400px"
        max-width="800px"
      >
          <v-card>
            <v-card-title>
              <span class="text-h5">Edit Rate</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="edit_rate.currencyname"
                      required
                      readonly
                      dense
                      persistent-hint
                      single-line hint="Currency Name"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="edit_rate.currencydate"
                      required
                      readonly
                      dense
                      persistent-hint
                      single-line hint="Currency Date"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="12">
                    <v-text-field
                      type="number"
                      v-model="edit_rate.currencyrate"
                      v-on:change="onChangeRate($event, 'currencyrate')"
                      required
                      dense
                      persistent-hint
                      single-line hint="Currency Rate"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="isEditRate=false; edit_rate={}"
              >
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="updateRate"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { formatStdDate } from '@/mixins/date';

export default {
  name: 'CurrencyList',
  data() {
    return {
      isDeleteRate: false,
      isEditRate: false,
      delete_rate: {},
      edit_rate: {},
      change_rate: {},
      item_seleted: [],
      header_items: [
        { text: 'Date', value: 'currencydate', width: '12%'},
        { text: 'Currency', value: 'currencybase'},
        { text: 'Rate', value: 'currencyrate', width: '15%'},
        { text: 'Actions', value: 'actions', sortable: false, width: '10%' },
      ],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      itemPerPage: 500,
    }
  },
  computed: {
    ...mapState('CurrencyRate', ['currencyrates', 'isReceiving', 'isDeleting', 'idToDelete', 'isUpdating']),
  },
  methods: {
    ...mapActions('CurrencyRate', ["deleteCurrencyRateRequest","getCurrencyRatesRequest", "updateCurrencyRateRequest"]),
    editCurrency(item) {
      this.$router.push({name: 'CurrencyRateEdit', params: item});
    },
    deleteCurrency(item) {
      this.deleteCurrencyRateRequest({_id: item._id});
      this.isDeleteRate = false;
    },
    deteleRateDialog(item) {
      this.isDeleteRate = true;
      this.delete_rate = {_id: item._id, currencybase: item.currencybase, currencycross: item.currencycross};
    },
    Refresh(){
      this.getCurrencyRatesRequest()
    },
    async updateRateDialog(item) {
      this.edit_rate = Object.assign({}, item);
      this.edit_rate.currencyrate = parseFloat(item.currencyrate.toFixed(2));
      this.edit_rate.currencydate = formatStdDate(item.currencydate);
      this.edit_rate.currencyname = `${item.currencybase} - ${item.currencycross}`;
      this.isEditRate = true;
    },
    async updateRate() {
      this.change_rate._id = this.edit_rate._id;
      await this.updateCurrencyRateRequest(this.change_rate);
      this.isEditRate = false;
    },
    onChangeRate(value, field) {
      this.change_rate[field] = value;
    },

  },
  async created () {
    await this.getCurrencyRatesRequest()
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
